import { useMyContext } from '../../../contexts/StateHolder';
import RenderItem from '../RenderItems/RenderItem';
import CategoryTitle from '../CategoryTitles/CategoryTitle';
import CategoryTitle2 from '../CategoryTitles/CategoryTitle2/CategoryTitle2';
import { useEffect, useState } from 'react';
import {
  getAssets,
  getSubCategories,
  getRootSubCategories,
} from '../../../scripts/dataHandlers';
import { createToken, createGroupItemId } from '../../../scripts/utils';
import Carousel from 'react-multi-carousel';
import * as classes from './CategoriesWithTitles.module.css';
import useWindowDimensions from '../../WindowDimension';
let updatedSlickSettings;

const components = {
  CategoryTitle,
  CategoryTitle2,
};

const RenderCategoriesWithTitles = (props) => {
  const windowDimension = useWindowDimensions();

  const {
    id,
    mode,
    groupItemId,
    routes,
    slickSettings,
    assetProperty,
    categoryTitleComponent,
    itemImageComponent,
    itemTitleComponent,
    maintainImageAspectRatio,
  } = props.settings;

  const [allCategoryItems, setAllCategoryItems] = useState([]);

  const { allCategories, organizationId, key, language, user } = useMyContext();

  // UseEffect that will check mode and context data by id, if component has already fetched items once
  useEffect(() => {
    const getDataFromAPI = async () => {
      try {
        let objectData = [];

        if (mode === 'mode_1') {
          const token = createToken(organizationId, groupItemId, key);

          const catList = await getSubCategories(
            organizationId,
            token,
            groupItemId,
            language,
            user
          );

          const itemList = await getAssets(
            organizationId,
            groupItemId,
            token,
            language,
            assetProperty,
            user
          );

          catList.forEach((cat) => {
            const assetsInCategory = itemList.filter((asset) =>
              asset.groupItemIds.includes(String(cat.id))
            );

            objectData.push({ category: cat, assets: assetsInCategory });
          });
        } else if (mode === 'mode_2') {
          console.log(`allCategories`, allCategories, user, 'user');
          const idString = createGroupItemId(allCategories);

          const token = createToken(organizationId, idString, key);

          let response = await getAssets(
            organizationId,
            idString,
            token,
            language,
            assetProperty,
            user
          );

          allCategories.forEach((cat) => {
            const assetsInCategory = response.filter((asset) =>
              asset.groupItemIds.includes(String(cat.id))
            );

            objectData.push({ category: cat, assets: assetsInCategory });
          });
        } else if (mode === 'mode_3') {
          const subCatList = await getRootSubCategories(
            organizationId,
            key,
            language,
            groupItemId,
            user
          );

          const idString = createGroupItemId(subCatList);

          const token = createToken(organizationId, idString, key);

          let response = await getAssets(
            organizationId,
            idString,
            token,
            language,
            assetProperty,
            user
          );

          subCatList.forEach((cat) => {
            const assetsInCategory = response.filter((asset) =>
              asset.groupItemIds.includes(String(cat.id))
            );

            objectData.push({ category: cat, assets: assetsInCategory });
          });
        } else if (mode === 'mode_4') {
          const token = createToken(organizationId, groupItemId, key);

          const catList = await getSubCategories(
            organizationId,
            token,
            groupItemId,
            language,
            user
          );

          await Promise.all(
            catList[0].groupItems.map(async (group) => {
              try {
                const token = createToken(organizationId, group.id, key);

                let response = await getAssets(
                  organizationId,
                  group.id,
                  token,
                  language,
                  assetProperty,
                  user
                );
                objectData.push({ category: group, assets: response });
              } catch (error) {
                console.log('error' + error);
              }
            })
          );
        }
        setAllCategoryItems(objectData);
      } catch (err) {
        console.log(err);
      }
    };

    if (
      allCategories?.length > 0 &&
      organizationId &&
      groupItemId &&
      key &&
      language &&
      slickSettings &&
      user
    ) {
      getDataFromAPI();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allCategories, slickSettings]);

  let className1 = '';
  const renderCategories = () => {
    return allCategoryItems.map((group) => {
      const TitleComponent = components[categoryTitleComponent];
      console.log(`group.assets`, group.assets);

      if (group.assets.length > 0 && slickSettings) {
        let arr = Object.keys(slickSettings.responsive).map(
          (k) => slickSettings.responsive[k]
        );
        let arr1 = [...arr];

        let j = [...arr1].find(
          (el) =>
            el.breakpoint.min <= windowDimension.width &&
            el.breakpoint.max >= windowDimension.width
        );

        if (group.assets.length === j.items) {
          className1 = 'addSeecondary';
        } else {
          className1 = '';
        }
      }
      console.log(updatedSlickSettings, group.assets.length);

      return group.assets.length > 0 ? (
        <div
          className={`${classes.categoriesContainer} ${className1}`}
          key={`${id} ${group.category.id}`}
        >
          <TitleComponent
            id={group.category.id}
            title={group.category.title}
            routes={routes}
            item={group.assets}
          />

          <Carousel {...slickSettings}>
            {group.assets.map((item, i) => {
              let pushRoute = '';
              if (item.isSerie === true || item.series?.length > 0) {
                pushRoute = `/${routes.serieRoute}/${organizationId}/${item.id}`; //${item.series[0].id}${item?.series[1]?.id ? "/"+item.series[1].id : ""}`
              } else {
                pushRoute = `/${routes.videoRoute}/${organizationId}/${item.id}`;
              }

              return (
                <RenderItem
                  key={`${id} ${i}`}
                  item={item}
                  routes={routes}
                  itemImageComponent={itemImageComponent}
                  itemTitleComponent={itemTitleComponent}
                  pushRoute={pushRoute}
                  imageType={'thumbnail'}
                  showCategoryName={true}
                  showPlayIcon={true}
                  // whether to maintain aspect ratio 16/9
                  maintainImageAspectRatio={maintainImageAspectRatio}
                  showDuration={props.showDuration}
                  showReleaseYear={props.showReleaseYear}
                  showPublishedDate={props.showPublishedDate}
                  hideDescription={props.hideDescription}
                />
              );
            })}
          </Carousel>
        </div>
      ) : null;
    });
  };
  return allCategoryItems.length > 0 ? renderCategories() : null;
};

export default RenderCategoriesWithTitles;
